module.exports = __webpack_public_path__ + "img/1.5f6d823a.png";